import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { ExploreButtonFilled } from "shared/pages/explore/styles";
import styled from "styled-components";

export const ConfirmWrapper = styled.div`
    position: absolute;
    inset: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999999;
`;

export const ConfirmContent = styled(FlexBox)`
    flex-flow: column;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    max-width: 560px;
    padding: 32px 40px;
    background: #fefefe;
`;

export const TextBlock = styled(FlexBox)`
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 16px;
`;

export const ConfirmText = styled.div`
    font-family: 'Inter', sans-serif;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    width: 100%;
    max-width: 480px;
    text-align: center;
    color: #151514;
    white-space: pre-line;

    a {
        color: inherit;
        text-decoration: underline;
    }
`;

export const SecondText = styled.div`
    font-family: 'Inter', sans-serif;
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    width: 100%;
    max-width: 480px;
    text-align: center;
    color: #151514;
    white-space: pre-line;
`;

export const ActionsWrapper = styled(FlexBox)`
    width: 100%;
    max-width: 480px;
    flex-direction: column;
    gap: 12px;
    margin-top: 32px;
`;

const modalButtonStyles = `
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    height: 48px !important;
    min-height: 48px !important;
    margin: 0 !important;

    @media (max-width: ${LayoutConst.screen.md}px) {
        height: 36px !important;
        min-height: 36px !important;
    }
`;

export const FilledButton = styled(ExploreButtonFilled)`
    ${modalButtonStyles}
    background-color: #151514 !important;
    color: #fefefe !important;
    border: 1px solid #151514 !important;

    &:hover {
        color: #fefefe !important;
    }
`;
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { ExploreButtonFilled } from "shared/pages/explore/styles";
import styled from "styled-components";

export const ConfirmWrapper = styled.div`
    position: absolute;
    inset: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999999;
`;

export const ConfirmContent = styled(FlexBox)`
    flex-flow: column;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    max-width: 560px;
    padding: 32px 40px;
    background: #fefefe;
`;

export const TextBlock = styled(FlexBox)`
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 16px;
`;

export const ConfirmText = styled.div`
    font-family: 'Inter', sans-serif;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    width: 100%;
    max-width: 480px;
    text-align: center;
    color: #151514;
    white-space: pre-line;

    a {
        color: inherit;
        text-decoration: underline;
    }
`;

export const SecondText = styled.div`
    font-family: 'Inter', sans-serif;
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    width: 100%;
    max-width: 480px;
    text-align: center;
    color: #151514;
    white-space: pre-line;
`;

export const ActionsWrapper = styled(FlexBox)`
    width: 100%;
    max-width: 480px;
    flex-direction: column;
    gap: 12px;
    margin-top: 32px;
`;

const modalButtonStyles = `
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    height: 48px !important;
    min-height: 48px !important;
    margin: 0 !important;

    @media (max-width: ${LayoutConst.screen.md}px) {
        height: 36px !important;
        min-height: 36px !important;
    }
`;

export const FilledButton = styled(ExploreButtonFilled)`
    ${modalButtonStyles}
    background-color: #151514 !important;
    color: #fefefe !important;
    border: 1px solid #151514 !important;

    &:hover {
        color: #fefefe !important;
    }
`;
